module.exports = __webpack_public_path__ + "static/media/icon_facebook.d43fc9a4.svg";